import { BuildFontString } from "../utils/BuildFontString";
import { enumChartRenderOrder, enumXMLType, kIndexPageLabelWidth } from "../constants";
import { QLinkText } from "./QLinkText";
import { QRect } from "./QRect";
import { XML_AddLinkToPPT } from "../utils/XML_AddLinkToPPT";
import { XML_DrawText } from "../utils/XML_DrawText";
import { XML_Param5 } from "../utils/XML_Param5";
import { XML_ScaleAndShiftX } from "../utils/XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "../utils/XML_ScaleAndShiftY";
import { SVG_DrawText } from "../utils/SVG_DrawText";
import { XML_AddLink } from "../utils/XML_AddLink";
import { MeasureText } from "../utils/MeasureText";
import { XML_Param4 } from "../utils/XML_Param4";
import { RoundTo3 } from "../utils/RoundTo3";
import { XML_Scale } from "../utils/XML_Scale";

export class QBoxPageLink extends QLinkText {
  constructor() {
    super();
    this.fChartBox = null;
    this.fDeltaDefX = 0;
    this.fDeltaDefY = 0;
    this.fAllowDeltaX = false;
    this.fAllowDeltaY = false;
    this.fKeepAspectRatio = false;
    this.fSubchart = null;
  }

  InitPageLink(chartBox, label, Subchart, offset) {
    this.fChartBox = chartBox;
    this.fDeltaDefX = kIndexPageLabelWidth - offset - 20;
    this.fSubchart = Subchart;
    this.InitStaticText();
    this.SetLabel(label);
    this.SetAlignment("left");
    this.PositionElement(300, 200);
    this.AutoSize();
    this.fDeltaDefX -= this.GetWidth();
    this.SetCmdCode("ChangeSubChart");
    this.SetZPlane(enumChartRenderOrder.overlay);
    this.fParentPanel = chartBox.fParentPanel;
  }

  AutoSize() {
    var fontFamily = "Verdana";
    var fontSize = this.fFontSize;
    var fs = BuildFontString(fontFamily, fontSize, false, false);
    if (this.fLabel) this.fWidth = MeasureText(this.fLabel, fs);
  }

  SetCmdParameters(aCmd) {
    aCmd["subchart"] = this.fSubchart;
  }

  SetAllowDeltaY(allowDeltaY) {
    this.fAllowDeltaY = allowDeltaY;
  }

  SetAllowDeltaX(allowDeltaX) {
    this.fAllowDeltaX = allowDeltaX;
  }

  SetKeepAspectRatio(keepAspectRatio) {
    this.fKeepAspectRatio = keepAspectRatio;
  }

  GetAssociatedBox() {
    return this.fChartBox;
  }

  DoAltRender(altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var theMessage = this.GetLabel();
    var x = this.GetPositionX();
    var y = this.GetPositionY();
    var width = this.GetWidth();
    var textColor = this.GetTextColor();
    var fontFamily = "Verdana";
    var fontSize = this.fFontSize;
    var bold = false;
    var italic = false;
    var underline = false;
    var alignment = this.GetAlignment();
    var vAlignment = "top";
    var layer = this.GetLayer();
    switch (altCanvasType) {
      case "SVG":
        SVG_DrawText(
          theMessage,
          x,
          y,
          textColor,
          fontFamily,
          fontSize,
          bold,
          italic,
          underline,
          alignment,
          vAlignment,
          null,
          altCanvasElement
        );
        break;
      case "XML":
        var docType = altCanvasElement.GetDocType();
        var linkBookmark = this.GetLinkBookmark();
        var x0 = XML_ScaleAndShiftX(x, altCanvasElement, layer);
        var y0 = XML_ScaleAndShiftY(y - 5, altCanvasElement, layer);
        var x1 = XML_ScaleAndShiftX(x + width, altCanvasElement, layer);
        var y1 = XML_ScaleAndShiftY(y + 15, altCanvasElement, layer);
        y0 = altCanvasElement.ConvertY(y0);
        y1 = altCanvasElement.ConvertY(y1);

        var clipRect = new QRect();
        clipRect.InitRect(x, y, x + width, y + 15);

        if (docType === enumXMLType.PDF) {
          XML_DrawText(
            theMessage,
            x,
            y,
            textColor,
            fontFamily,
            fontSize,
            bold,
            italic,
            underline,
            alignment,
            vAlignment,
            clipRect,
            altCanvasElement,
            layer
          );
          if (linkBookmark != null) XML_AddLink(altCanvasElement, linkBookmark, x0, y0, x1, y1);
        } else {
          y0 = XML_ScaleAndShiftY(y, altCanvasElement, layer);
          XML_Param4(
            "t",
            RoundTo3(x0),
            RoundTo3(y0),
            RoundTo3(width + 12),
            RoundTo3(y1 - y0),
            altCanvasElement
          );
          var biString = "";
          if (italic) biString = biString + "I ";
          if (bold) biString = biString + "B ";
          if (underline) biString = biString + "U ";
          fontSize = XML_Scale(fontSize, altCanvasElement, layer);
          alignment = "left";
          XML_Param5(
            "f",
            fontFamily,
            biString,
            textColor,
            RoundTo3(fontSize),
            alignment,
            altCanvasElement
          );
          var fs = BuildFontString(fontFamily, this.fFontSize, bold, italic);
          var widthfontSize = MeasureText(theMessage, fs);
          XML_DrawText(
            theMessage,
            x,
            y,
            textColor,
            fontFamily,
            this.fFontSize,
            bold,
            italic,
            underline,
            alignment,
            vAlignment,
            clipRect,
            altCanvasElement,
            layer,
            widthfontSize
          );
          if (linkBookmark != null) XML_AddLinkToPPT(linkBookmark, altCanvasElement);
        }
        break;
    }
  }

  GetLinkBookmark() {
    var scid = this.fSubchart.GetSubChartID();
    return this.fParentPanel.GetLinkBookmark(scid);
  }
}
